import Swiper, {Autoplay} from 'swiper';
export default class LogoCarousel {

    constructor () {

    }

    init() {
        this.initSwiper('.logo-swiper-carousel', 'logo-swiper-top', true);
        this.initSwiper('.logo-swiper-carousel-bottom', 'logo-swiper-bottom', false);
    }

    initSwiper(containerClass, containerId, reversed) {

        let swiperContainer = document.querySelector(containerClass);
        if(swiperContainer) {
            swiperContainer.querySelector('.uael-gallery-parent').id = containerId;
            swiperContainer.querySelector('.uael-gallery-parent').classList.add('swiper-container');
            swiperContainer.querySelector('.uael-img-gallery-wrap').classList.add('swiper-wrapper');
            swiperContainer.querySelector('.uael-img-gallery-wrap').classList.add('transition-linear');
            swiperContainer.querySelector('.uael-img-gallery-wrap').style.flexWrap = 'nowrap';
            let galleryItems = swiperContainer.querySelectorAll('.uael-grid-item');
            if(galleryItems.length <= 10) {
                let itemsToDuplicate = swiperContainer.querySelector('.uael-img-gallery-wrap').innerHTML;
                swiperContainer.querySelector('.uael-img-gallery-wrap').innerHTML += itemsToDuplicate + itemsToDuplicate;
            }
            swiperContainer.querySelectorAll('.uael-grid-item').forEach(item => {
                item.classList.add('swiper-slide');
            });
            new Swiper(`#${containerId}`, {
                spaceBetween: 0,
                centeredSlides: true,
                speed: 5000,
                autoplay: {
                    delay: 1,
                    reverseDirection: reversed
                },
                loop: true,
                slidesPerView: 'auto',
                allowTouchMove: false,
                disableOnInteraction: true,
                modules: [Autoplay]
            });
        }
    }
}